export default __webpack_public_path__ + "static/media/bw-planning-tutorial-pop-up-step-3.688af455.svg";